import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/auth/actions";
import { useEffect, useRef, useState } from "react";
import storePersist from "../../redux/storePersist";
import { selectCurrent } from "../../redux/settings/selectors";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import { selectOrganizationUnitsListItems } from "../../redux/organizationUnits/selector";

const Sidebar = () => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  let items: any = []
  let subitems: any = []
  let menuitems: any = []
  const result = useSelector(selectCurrent)
  const { sidebar, theme } = result
  const [color, setColor] = useState('universal')
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeSubIndex, setActiveSubIndex] = useState(null);
  const navigate = useNavigate()
  const [open, setOpen] = useState(items)
  const [isMore, setIsMore] = useState(false)
  const [subOpen, setSubOpen] = useState(subitems)
  const [menuOpen, setMenuOpen] = useState(menuitems)
  const [logo, setLogo] = useState<any>()
  const organizationLists = useSelector(selectOrganizationUnitsListItems)
  const fetchLogo = () => {

    const storeData = {
      logoDark: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
        return logo.Background === 'Light'
      }),
      logoLight: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
        return logo.Background === 'Dark'
      }),
      storeName: organizationLists?.result?.items[0]?.BrandMappings[0]?.Name,
      description: organizationLists?.result?.items[0]?.BrandMappings[0]?.Description,
      favicon: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Favicons[0]?.Url || '/assets/images/logo.png'
    }
    setLogo(storeData)
  }

  const [menus, setMenus] = useState([

    {
      id: `main-menu-2-all`,
      path: '/rap/home',
      label: 'Business Advisor',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1.207 6.717L8.92 12.82a.5.5 0 0 1-.707.002l-.002-.002-1.414-1.414a.5.5 0 0 1 .002-.707l.002-.002 2.5-2.5a.5.5 0 0 1 .708 0l4.5 4.5a.5.5 0 0 1 0 .707l-2.5 2.5a.5.5 0 0 1-.706-.001l-.002-.002-1.415-1.415a.5.5 0 0 1-.001-.707l.001-.002 1.416-1.415z" />
          </g>
        </svg>

      ),
      subMenu: [

        {
          id: `coln-1-collections`,
          label: 'Dashboard',
          path: '/rap/home',
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M3.75 4.5L4.5 3.75H10.5L11.25 4.5V10.5L10.5 11.25H4.5L3.75 10.5V4.5ZM5.25 5.25V9.75H9.75V5.25H5.25ZM12.75 4.5L13.5 3.75H19.5L20.25 4.5V10.5L19.5 11.25H13.5L12.75 10.5V4.5ZM14.25 5.25V9.75H18.75V5.25H14.25ZM3.75 13.5L4.5 12.75H10.5L11.25 13.5V19.5L10.5 20.25H4.5L3.75 19.5V13.5ZM5.25 14.25V18.75H9.75V14.25H5.25ZM12.75 13.5L13.5 12.75H19.5L20.25 13.5V19.5L19.5 20.25H13.5L12.75 19.5V13.5ZM14.25 14.25V18.75H18.75V14.25H14.25Z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
          isEnabled: true,

        },

      ],
    },
    {
      id: `main-menu-2-all`,
      path: '/rap/logistics/transport/leads',
      label: 'Sales',
      isEnabled: true,
      svg: (
        <svg className="h-6 w-6 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M5 10.5a.5.5 0 0 1 .5-.5H7v-3a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v3h1.5a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5H5.5a.5.5 0 0 1-.5-.5v-9zm9-5a3.5 3.5 0 0 1 0 7 3.5 3.5 0 0 1 0-7zm-6 9h8v-2H8v2zm0 3h8v-2H8v2z" />
          </g>
        </svg>

      ),
      Description: 'Sales encompass a wide range of operations and activities aimed at effectively promoting, marketing, and selling goods or services to customers, ensuring business growth and customer satisfaction.',
      subMenu: [
        {
          id: `coln-1-collections`,
          label: 'Leads',
          path: '/rap/logistics/transport/leads',
          isEnabled: true,
          svg: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-4 w-4 mr-1" fill="#007BFF">
              <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 22c-5.524 0-10-4.476-10-10S6.476 2 12 2s10 4.476 10 10-4.476 10-10 10zm-1-15h-2v2h2v-2zm0 4h-2v2h2v-2zm5 1h-2v2h2v-2zm2-4h-2v2h2V8zm-3 7h-2v2h2v-2zM8 12H6v2h2v-2z" />
            </svg>


          ),

        },
        {
          id: `coln-1-Categories`,
          label: 'Quotes',
          path: '/rap/logistics/transport/logistics-quotes',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="#007BFF" d="M4 4v4h4V4H4zm0 6v4h4v-4H4zm6-6v4h4V4h-4zm0 6v4h4v-4h-4zm6-6v4h4V4h-4zm0 6v4h4v-4h-4z" />
            </svg>

          ),
        },
        {
          id: `coln-1-Products`,
          label: 'Orders',
          path: '/rap/logistics/transport/shipments',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="#007BFF" d="M4 2h16a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 2v14h16V4H4zm2 2h12v2H6V6zm0 4h12v2H6v-2zm0 4h12v2H6v-2z" />
            </svg>

          ),
        },

      ],
    },

    {
      id: `main-menu-2-all`,
      path: '/rap/logistics/transport/transport-agents',
      label: 'Transporter Manager',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill="#ffffff" d="M16 3H8a1 1 0 0 0-1 1v2H3v2h1v11a1 1 0 0 0 1 1h1a3 3 0 0 0 6 0h4a3 3 0 0 0 6 0h1a1 1 0 0 0 1-1V8h1V6h-4V4a1 1 0 0 0-1-1zm-7 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm10 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm1-4H5V9h14v5zm-2-7H7V5h10v2z" />
        </svg>

      ),
      subMenu: [
        {
          id: `coln-1-collections`,
          label: 'Agent',
          path: '/rap/logistics/transport/transport-agents',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="#007BFF" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
            </svg>
          ),
        },


      ],
    },
    {
      id: `main-menu-2-all`,
      path: '/rap/logistics/route-management/regions',
      label: 'Route Management',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill="#ffffff" d="M10.707 7.293a1 1 0 0 0-1.414 0L5 11.586V10a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2H6.414l4.293-4.293a1 1 0 0 0 0-1.414zM18 3h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 6.414V8a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1zm2 14h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 19.414V21a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1z" />
        </svg>

      ),
      Description: 'Route management optimizes and streamlines the planning, tracking, and execution of routes, enabling businesses to enhance efficiency, reduce costs, and improve customer satisfaction.',
      subMenu: [
        {
          id: `coln-1-collections`,
          label: 'Region',
          path: '/rap/logistics/route-management/regions',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="#007BFF" d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8zm4-10h-3V7a1 1 0 0 0-2 0v3H8a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2z" />
            </svg>

          ),
        },
        {
          id: `coln-1-collections`,
          label: 'Routes',
          path: '/rap/logistics/route-management/routes',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="#007BFF" d="M10.707 7.293a1 1 0 0 0-1.414 0L5 11.586V10a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2H6.414l4.293-4.293a1 1 0 0 0 0-1.414zM18 3h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 6.414V8a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1zm2 14h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 19.414V21a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1z" />
            </svg>
          ),
        },
        {
          id: `coln-1-collections`,
          label: 'Route Points',
          path: '/rap/logistics/route-management/route-points',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="#007BFF" d="M12 2C7.59 2 4 5.59 4 10c0 6.49 8 12 8 12s8-5.51 8-12c0-4.41-3.59-8-8-8zm0 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-2-6H8c0-2.21 1.79-4 4-4V6c-3.31 0-6 2.69-6 6h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4z" />
            </svg>

          ),
        },
        {
          id: `coln-1-collections`,
          label: 'Zone',
          path: '/rap/logistics/zones',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="#007BFF" d="M12 2a10 10 0 0 0-10 10 10 10 0 0 0 3.512 7.598l.494.452 1.728-1.796-.573-.524a8 8 0 1 1 11.678 0l-.573.524 1.728 1.796.494-.452A10 10 0 0 0 22 12a10 10 0 0 0-10-10zm0 4a6 6 0 0 0-6 6 6 6 0 0 0 6 6 6 6 0 0 0 6-6 6 6 0 0 0-6-6zm0 4a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2z" />
            </svg>


          ),
        },
      ],
    },
    {
      id: `main-menu-2-all`,
      path: '/rap/policy/shipment/rate-cards',
      label: 'Policy Manager',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill="#ffffff" d="M12 2L4 5v6c0 5.52 3.58 10.74 8 12 4.42-1.26 8-6.48 8-12V5l-8-3zM12 4.24l6 2.18v5.73c0 4.52-2.91 8.91-6 10.31-3.09-1.4-6-5.79-6-10.31V6.42l6-2.18zm1 5.76v-2h-2v2H8v2h3v2h2v-2h3v-2h-3z" />
        </svg>

      ),
      Description: 'Policy manager centralizes and simplifies the administration, creation, and enforcement of policies, ensuring compliance, consistency, and control across the platform.',
      subMenu: [

        {
          id: `coln-1-collections`,
          label: 'RateCards',
          path: '/rap/policy/shipment/rate-cards',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="#007BFF" d="M19 2H5C3.9 2 3 2.9 3 4V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V4C21 2.9 20.1 2 19 2ZM19 4V6H5V4H19ZM5 20V8H19V20H5ZM7 11H17V13H7V11ZM7 15H17V17H7V15Z" />
            </svg>

          ),
        },

      ],
    },
  ])

  menus.map((item) => {
    items.push({ open: true, isActive: false })
    item.subMenu.map((obj: any) => {
      obj?.subMenu?.map((obj1) => {
        menuitems.push({ open: true, isActive: false })
      })
      subitems.push({ open: true, isActive: false })
    })
  })
  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      let menu = [...open]
      open?.map((obj: any, idx: any) => {
        // menu[idx].isActive = false
        menu[idx].open = true
      })
      setOpen(menu)
      let menu1 = [...subOpen]
      subOpen?.map((obj: any, idx: any) => {
        // menu1[idx].isActive = false
        menu1[idx].open = true
      })
      setSubOpen(menu1)
      let menu2 = [...menuitems]
      menuitems?.map((obj: any, idx: any) => {
        // menu2[idx].isActive = false
        menu2[idx].open = true
      })
      setMenuOpen(menu2)

    }
  };
  const handleItemClick = (index: any) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const handleSubItemClick = (index: any) => {
    setActiveSubIndex(index === activeSubIndex ? null : index);
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [])
  const handleSideBarView = () => {
    dispatch(settings.set({ sidebar: !sidebar }))
  }
  const dispatch = useAppDispatch();

  const handleNavigate = (path: any) => {
    navigate(`${path}`)
  }

  const handleMenu = (index: any, index1: any) => {
    let menu = [...open]
    open?.map((obj: any, idx: any) => {
      if (idx == index) {
        menu[idx].open = !obj.open
        menu[idx].isActive = true
      }
      else {
        menu[idx].open = true
        menu[idx].isActive = false
      }
    })
    setOpen(menu)

  }

  const handleSubMenu = (e: any, index: any) => {
    e.stopPropagation()
    let menu = [...subOpen]
    subOpen?.map((obj: any, idx: any) => {
      if (idx == index) {
        menu[idx].open = !obj.open
        menu[idx].isActive = true
      }
      else {
        menu[idx].open = true
        menu[idx].isActive = false
      }
    })
    setSubOpen(menu)
  }

  const handleItems = (e: any, itemIndex: any) => {
    e.stopPropagation()

    let menu2 = [...menuitems]
    menuitems?.map((obj: any, idx: any) => {
      if (idx == itemIndex) {
        menu2[idx].isActive = true
        menu2[idx].open = !obj.open
      }
      else {
        menu2[idx].isActive = false
        menu2[idx].open = true
      }
    })
    setMenuOpen(menu2)
  }

  const beginWord = (sentence: string | undefined | null) => {
    if (!sentence || typeof sentence !== 'string') {
      return '';
    }

    const words = sentence.trim().split(/\s+/);

    if (words.length === 0) {
      return '';
    }
    if (sentence.length > 19) {
      const lastWord = words.pop() as string;
      let transformedSentence = ""
      if (words.length == 1) {
        transformedSentence = `${words[0]} `;
      }
      else if (words.length == 2)
        transformedSentence = `${words[0]} ${words[1]}`;
      return transformedSentence
    }
    else {
      return sentence
    }
  }

  const endWord = (sentence: string | undefined | null) => {
    if (!sentence || typeof sentence !== 'string') {
      return '';
    }

    const words = sentence.trim().split(/\s+/);

    if (words.length === 0) {
      return '';
    }
    if (sentence.length > 19) {
      const lastWord = words.pop() as string;
      return lastWord
    }

  }

  return (
    <>

      {sidebar ? <div className="w-64 fixed md:top-0 md:left-0 h-screen lg:block bg-primary text-light z-10" >
        {sidebar &&
          <div className={`w-full flex flex-col justify-end items-end p-2 pr-4 mt-20 lg:mt-20 md:mt-20`}>
            <svg
              onClick={() => dispatch(settings.set({ sidebar: !sidebar }))}
              width="22" height="22" viewBox="0 0 24 24" fill="none" className="cursor-pointer hover:stroke-hilight">
              <title>Show Less Infomation</title>
              <path stroke-width="1.25" d="M12.6772 19.5377C12.9742 19.8265 13.449 19.8198 13.7377 19.5228C14.0265 19.2258 14.0198 18.751 13.7228 18.4623L12.6772 19.5377ZM6 12L5.47719 11.4623C5.33195 11.6035 5.25 11.7974 5.25 12C5.25 12.2026 5.33195 12.3965 5.47719 12.5377L6 12ZM13.7228 5.53775C14.0198 5.24901 14.0265 4.77418 13.7377 4.47719C13.449 4.1802 12.9742 4.17351 12.6772 4.46225L13.7228 5.53775ZM17.4772 18.3708C17.7742 18.6595 18.249 18.6528 18.5378 18.3558C18.8265 18.0588 18.8198 17.584 18.5228 17.2952L17.4772 18.3708ZM12 12L11.4772 11.4622C11.332 11.6035 11.25 11.7974 11.25 12C11.25 12.2026 11.332 12.3965 11.4772 12.5378L12 12ZM18.5228 6.70476C18.8198 6.41603 18.8265 5.9412 18.5378 5.64421C18.249 5.34721 17.7742 5.34051 17.4772 5.62924L18.5228 6.70476ZM13.7228 18.4623L6.52281 11.4623L5.47719 12.5377L12.6772 19.5377L13.7228 18.4623ZM6.52281 12.5377L13.7228 5.53775L12.6772 4.46225L5.47719 11.4623L6.52281 12.5377ZM18.5228 17.2952L12.5228 11.4622L11.4772 12.5378L17.4772 18.3708L18.5228 17.2952ZM12.5228 12.5378L18.5228 6.70476L17.4772 5.62924L11.4772 11.4622L12.5228 12.5378Z" fill="#f8f8f8" />
            </svg>
          </div>
        }
        <div className="h-[calc(100vh-10rem)] overflow-auto">
          <div className="mb-4  px-4 h-max ">

            {menus.map((obj: any, index1: any) => {
              return <li
                onClick={() => handleMenu(index1, null)}
                className={`w-full flex flex-col justify-start space-y-3 `}>
                <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary  hover:text-black" ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} `}>
                  {obj?.svg}
                  <span className="hover:text-black w-36 text-sm ">{obj.label}</span>
                </div>
                {obj?.subMenu?.map((obj1: any, index2: any) => {
                  return <ul
                    onClick={(e) => handleSubMenu(e, index2)}
                    className={`w-full flex pl-2 flex-col justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'ml-2'} `}>
                    <div className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                      {obj1?.svg}
                      <div onClick={() => handleNavigate(obj1?.path)} className="text-light  text-sm dark:text-slate-200 hover:text-black w-36  flex flex-col w-auto justify-center items-end">
                        <span className="">{beginWord(obj1.label)}</span>
                        <span className="text-right text-xs italic">{endWord(obj1.label)}</span>
                      </div>
                    </div>
                    {obj1?.subMenu?.map((obj2: any, index3: any) => {
                      return <li
                        onClick={(e) => handleItems(e, index3)}
                        className={`w-full flex flex-col pl-2 justify-start space-y-3  ${subOpen[index2]?.open ? 'hidden' : 'ml-2'} `}>
                        <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary hover:text-black"  ${menuOpen[index3]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                          {obj2?.svg}
                          <div onClick={() => handleNavigate(obj2?.path)} className="text-sm dark:text-slate-200 hover:text-black w-36 flex flex-col w-auto justify-center items-end">
                            <span className="">{beginWord(obj2.label)}</span>
                            <span className="text-right text-xs italic"> {endWord(obj2.label)}</span>
                          </div>
                        </div>
                      </li>
                    })}
                  </ul>
                })}
              </li>
            })}
          </div>
        </div>
      </div> : <div ref={dropdownRef} className="w-24 fixed md:top-0 md:left-0 h-screen lg:block bg-primary text-light z-10" >

        <div className="">
          {!sidebar &&
            <div className={`w-full flex flex-col justify-end items-end p-2 mt-20 lg:mt-20 md:mt-20`}>
              <svg
                onClick={() => dispatch(settings.set({ sidebar: !sidebar }))}
                width="22" height="22" viewBox="0 0 24 24" fill="none" className="cursor-pointer hover:stroke-hilight">
                <title>Show More Infomation</title>
                <path stroke-width="1.25" d="M10.2772 18.4623C9.9802 18.751 9.97351 19.2258 10.2623 19.5228C10.551 19.8198 11.0258 19.8265 11.3228 19.5377L10.2772 18.4623ZM18 12L18.5228 12.5377C18.6681 12.3965 18.75 12.2026 18.75 12C18.75 11.7974 18.6681 11.6035 18.5228 11.4623L18 12ZM11.3228 4.46225C11.0258 4.17351 10.551 4.1802 10.2623 4.47719C9.97351 4.77418 9.9802 5.24901 10.2772 5.53775L11.3228 4.46225ZM5.47721 17.2952C5.18021 17.584 5.17351 18.0588 5.46224 18.3558C5.75097 18.6528 6.2258 18.6595 6.52279 18.3708L5.47721 17.2952ZM12 12L12.5228 12.5378C12.668 12.3965 12.75 12.2026 12.75 12C12.75 11.7974 12.668 11.6035 12.5228 11.4622L12 12ZM6.52279 5.62924C6.2258 5.34051 5.75097 5.34721 5.46224 5.64421C5.17351 5.9412 5.18021 6.41603 5.47721 6.70476L6.52279 5.62924ZM11.3228 19.5377L18.5228 12.5377L17.4772 11.4623L10.2772 18.4623L11.3228 19.5377ZM18.5228 11.4623L11.3228 4.46225L10.2772 5.53775L17.4772 12.5377L18.5228 11.4623ZM6.52279 18.3708L12.5228 12.5378L11.4772 11.4622L5.47721 17.2952L6.52279 18.3708ZM12.5228 11.4622L6.52279 5.62924L5.47721 6.70476L11.4772 12.5378L12.5228 11.4622Z" fill="#f8f8f8" />
              </svg>
            </div>
          }
          <div className="mb-4 px-4 h-max ">
            <ul className="w-full flex flex-col justify-start space-y-3">

              {!isMore && menus.map((barmenu: any, index1: any) => {
                return <li
                  className={`flex items-center h-10 ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} ${index1 > 7 ? 'hidden' : ""} `}
                  onClick={() => handleMenu(index1, null)} >
                  <div className={`flex flex-row justify-start  rounded-lg  px-4  cursor-pointer  h-10 items-center hover:bg-secondary  max-w-24  hover:text-black"`}>
                    {barmenu?.svg}
                  </div>
                  <ul className={`flex flex-col space-y-3 items-center  max-h-[300px] max-w-56 overflow-auto justify-start  py-5 px-3  bg-primary text-light ml-0 ${index1 > 4 ? "mt-[calc(100vh-55rem)]" : "mt-auto"} rounded-r-xl min-w-64  font-medium text-sm  "  ${open[index1]?.open ? 'hidden' : 'ml-4'}`}>
                    {barmenu?.subMenu?.map((obj1: any, index2: any) => {
                      return <ul
                        onClick={(e) => handleSubMenu(e, index2)}
                        className={`w-full flex pl-2 flex-col  justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'pl-2'} `}>
                        <div className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                          {obj1?.svg}
                          <div onClick={() => handleNavigate(obj1?.path)} className="text-light  text-sm dark:text-slate-200 hover:text-black   flex flex-col w-auto justify-center items-end">

                            <span className="">{beginWord(obj1.label)}</span>
                            <span className="text-right text-xs italic">{endWord(obj1.label)}</span>
                          </div>
                        </div>
                        {obj1?.subMenu?.map((obj2: any, index3: any) => {
                          return <li
                            onClick={(e) => handleItems(e, index3)}
                            className={`w-full flex flex-col pl-2 justify-start space-y-3  ${subOpen[index2]?.open ? 'hidden' : 'ml-2'} `}>
                            <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary hover:text-black"  ${menuOpen[index3]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                              {obj2?.svg}
                              <div onClick={() => handleNavigate(obj2?.path)} className="text-sm dark:text-slate-200 hover:text-black w-36 flex flex-col w-auto justify-center items-end">

                                <span className="">{beginWord(obj2.label)}</span>
                                <span className="text-right text-xs italic"> {endWord(obj2.label)}</span>
                              </div>
                            </div>
                          </li>
                        })}
                      </ul>
                    })}
                  </ul>
                </li>
              })}

            </ul>
          </div>
        </div>

      </div>}


    </>
  )
}

export default Sidebar;